import { PropertyConfig } from "@cervval.js/common/src/forms/propertyConfig";
import { PropertyConfigType } from "@cervval.js/common/src/forms/propertyConfig.types";
import { keyof } from "@cervval.js/common/src/tools/object.tools";
import { BookingException } from "../data/booking.dto";
import { I18nPropertyConfig } from "./propertyConfig.i18n";

/** */
export function getCalendarExceptionPropertyConfig(): PropertyConfig[] {
    return [
        {
            propertyName: keyof<BookingException>("start"),
            label: I18nPropertyConfig().timeslot.start,
            typeUid: PropertyConfigType.DATE
        },
        {
            propertyName: keyof<BookingException>("finish"),
            label: I18nPropertyConfig().timeslot.finish,
            typeUid: PropertyConfigType.DATE
        }
    ];
}